export class BuyerRefNo{
    buyerExternalRefNo : string;
    constructor(buyerExternalRefNo : string)
    {
        this.buyerExternalRefNo = buyerExternalRefNo;
    }
}

export class NotificationRequest{
fromMailId:string;
toMailId:string;
subject:string;
description:string;
constructor(fromMailId:string,
    toMailId:string,
    subject:string,
    description:string,){
        this.fromMailId=fromMailId
        this.toMailId=toMailId
        this.subject=subject
        this.description=description
    }


}

